import styled from 'styled-components';
import { Card, TextField, createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) =>
  createStyles({
    mb30: {
      'margin-bottom': '30px'
    },
    successScreenContent: {
      display: 'flex',
      height: '100%',
      'flex-direction': 'column',
      'justify-content': 'center',
      padding: '15px !important',
      borderRadius: '15px'
    },
    descriptionMessage: {
      fontSize: '17px !important',
      color: '#12253F !important'
    }
  })
);

export const CardWrapper = styled(Card)`
  margin: 100px auto;
  width: 485px;
  border-radius: 15px;
  background-color: #ffffff;
  box-shadow: 0 12px 19px 0 rgba(60, 128, 209, 0.09);
  height: auto;
  padding: 20px;
`;

export const CardTitle = styled.p`
  color: #12253f;
  font-family: 'TTCommons';
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
  text-align: center;
  margin-bottom: 20px;
`;

export const CenterRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const TextCenter = styled.p`
  color: #12253f;
  font-family: 'TTCommons';
  font-size: 15px;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
`;

export const ButtonBackWrapper = styled.div`
  width: 50%;
  .MuiButton-label {
  padding-top: 0;
  padding-bottom: 0;
  }
`;
